module.exports = "##### User Interface (UI)\n\nThese are used as layers on top of app backgrounds. Cards and Popovers for example use our UI backgrounds.\n"